const Line = ({onClick, month, day, createdBy, title, message, isRead, timeAgo, initials, avatar }) => {
    return (
        <div 
            className={`main-content__timeline-item${!isRead ? ' main-content__timeline-item--active' : ''}`}
            onClick={onClick}>
            <div className="main-content__timeline-date">
                <i className="fa-light fa-calendar-lines"></i>
                <span>{month}</span>
                <span>{day}</span>
            </div>
            <div className="main-content__timeline-notification">
                <div className="main-content__timeline-user">
                        {avatar && avatar.trim() !== "" ? (
                            <img src={avatar} alt="Profile Image" />
                        ) : (
                                <div className="main-content__timeline-user-initials">
                                    <span>{initials}</span>
                                </div>
                        )}
            </div>
                <div className="main-content__timeline-body">
                    <div className="main-content__timeline-user-name">{createdBy}</div>
                    <div className="main-content__timeline-action">{title}</div>
                    <div className="main-content__timeline-message" dangerouslySetInnerHTML={{ __html: message }} />
                    <div className="main-content__timeline-time">
                        <span>{timeAgo} </span>
                        <span>ago</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Line;
